(function () {
  var FAVORITES_URL = '/apps/valthea-favorites';
  var favoriteProductIds = new Set();
  var favoritesLoaded = false;
  var favoriteProducts = [];

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function productKey(item) {
    return String(item.productId || item.id || item.urlHandle || '');
  }

  function syncFavoriteButtons() {
    document.querySelectorAll('.valthea-card-favorite').forEach(function (button) {
      var active = favoriteProductIds.has(button.getAttribute('data-favorite-key'));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Remove from saved items' : 'Save item');
      var label = button.querySelector('span');
      if (label) label.textContent = active ? 'Saved' : 'Save item';
    });
  }

  function loginRedirect() {
    var context = window.ValtheaFavoriteContext || {};
    var loginUrl = context.loginUrl || '/account/login';
    var returnUrl = window.location.pathname + window.location.search;
    window.location.href = loginUrl + '?return_url=' + encodeURIComponent(returnUrl);
  }

  function firstPicture(value) {
    if (!value) return '';
    return String(value).split(',')[0].trim();
  }

  function renderFavoriteList() {
    var html = favoriteProducts.map(function (item) {
      var id = escapeHtml(item.productId);
      var title = escapeHtml(item.name || 'Product');
      var handle = encodeURIComponent(item.handle || '');
      var image = escapeHtml(firstPicture(item.pictures));
      var price = item.price == null ? '' : escapeHtml(item.price);
      return '<article class="valthea-favorite-item">' +
        '<a href="/products/' + handle + '">' +
          (image ? '<img src="' + image + '" alt="' + title + '" loading="lazy" width="480" height="480">' : '') +
          '<h5>' + title + '</h5>' +
          (price ? '<p>' + price + '</p>' : '') +
        '</a>' +
        '<button type="button" class="valthea-card-favorite is-active valthea-favorite-remove" data-favorite-key="' + id + '" aria-label="Remove ' + title + '" aria-pressed="true">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.7 3.6 13A5.4 5.4 0 0 1 11.2 5.3L12 6l.8-.7A5.4 5.4 0 0 1 20.4 13L12 20.7Z"/></svg>' +
        '</button></article>';
    }).join('');
    document.querySelectorAll('[data-valthea-favorites-list]').forEach(function (root) {
      var status = root.querySelector('.valthea-favorites-status');
      var grid = root.querySelector('.valthea-favorites-grid');
      status.textContent = favoriteProducts.length ? '' : 'You have no saved items yet.';
      grid.innerHTML = html;
    });
    document.querySelectorAll('[data-valthea-favorite-count]').forEach(function (node) {
      node.textContent = String(favoriteProductIds.size);
    });
  }

  function installSavedItemsDrawer() {
    if (document.querySelector('.valthea-saved-launcher')) return;
    var context = window.ValtheaFavoriteContext || {};
    var account = document.querySelector('a.header--account') || document.querySelector('a[href*="customer_authentication"], a[href*="/account"]');
    if (!account) return;
    var launcher = document.createElement('button');
    launcher.type = 'button';
    launcher.className = 'valthea-saved-launcher';
    launcher.setAttribute('aria-label', 'Open saved items');
    launcher.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.7 3.6 13A5.4 5.4 0 0 1 11.2 5.3L12 6l.8-.7A5.4 5.4 0 0 1 20.4 13L12 20.7Z"/></svg><span>Saved</span><b data-valthea-favorite-count>0</b>';
    account.insertAdjacentElement('beforebegin', launcher);
    var drawer = document.createElement('div');
    drawer.className = 'valthea-saved-drawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML = '<button class="valthea-saved-backdrop" type="button" aria-label="Close saved items"></button>' +
      '<aside role="dialog" aria-modal="true" aria-label="Saved items"><header><h3>Saved items</h3><button type="button" class="valthea-saved-close" aria-label="Close">×</button></header>' +
      '<div class="valthea-drawer-favorites" data-valthea-favorites-list><div class="valthea-favorites-status">Loading saved items…</div><div class="valthea-favorites-grid"></div></div></aside>';
    document.body.appendChild(drawer);
    function closeDrawer() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
    launcher.addEventListener('click', function () {
      if (!context.loggedIn) { loginRedirect(); return; }
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); renderFavoriteList();
    });
    drawer.querySelector('.valthea-saved-close').addEventListener('click', closeDrawer);
    drawer.querySelector('.valthea-saved-backdrop').addEventListener('click', closeDrawer);
  }

  function installProductFavoriteButton() {
    var context = window.ValtheaFavoriteContext || {};
    if (!context.product || !context.product.id || document.querySelector('.valthea-product-favorite')) return;
    var target = document.querySelector('product-buy-buttons-element') || document.querySelector('.product-buy-buttons--primary');
    if (!target) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'valthea-product-favorite valthea-card-favorite';
    button.setAttribute('data-favorite-key', String(context.product.id));
    button.setAttribute('aria-pressed', 'false');
    button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.7 3.6 13A5.4 5.4 0 0 1 11.2 5.3L12 6l.8-.7A5.4 5.4 0 0 1 20.4 13L12 20.7Z"/></svg><span>Save item</span>';
    target.insertAdjacentElement('afterend', button);
  }

  function loadFavorites() {
    return fetch(FAVORITES_URL, {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (response.status === 401) {
        favoritesLoaded = true;
        return null;
      }
      if (!response.ok) throw new Error('Unable to load favorites');
      return response.json();
    }).then(function (result) {
      if (result && result.data && Array.isArray(result.data.productIds)) {
        favoriteProductIds = new Set(result.data.productIds.map(String));
        favoriteProducts = Array.isArray(result.data.products) ? result.data.products : [];
      }
      favoritesLoaded = true;
      syncFavoriteButtons();
      renderFavoriteList();
    }).catch(function (error) {
      favoritesLoaded = true;
      console.error('Favorite list request failed', error);
    });
  }

  function renderMedia(item, hoverImage, productType) {
    var handle = escapeHtml(item.urlHandle);
    var href = '/products/' + encodeURIComponent(item.urlHandle || '');
    var image = escapeHtml(item.imageUrl || '');
    var secondaryImage = escapeHtml(hoverImage || item.imageUrl || '');
    var title = escapeHtml(item.name || (productType === 'ring' ? 'Ring setting' : 'Lab-grown diamond'));
    var key = escapeHtml(productKey(item));
    var isFavorite = favoriteProductIds.has(productKey(item));
    var badgeText = String(item.type || '')
      .split(',')
      .map(function (tag) { return tag.trim(); })
      .map(function (tag) {
        var match = tag.match(/^badge\s*:\s*(.+)$/i);
        return match ? match[1].trim() : '';
      })
      .find(Boolean) || '';
    var badge = escapeHtml(badgeText);
    var badgeMarkup = badge
      ? '<span class="valthea-card-badge" title="' + badge + '">' + badge + '</span>'
      : '';

    return '<div class="valthea-card-media">' +
      '<a href="' + href + '" class="product-card--image-wrapper valthea-card-image-link" aria-label="View ' + title + '">' +
        '<img src="' + image + '&amp;width=1000" alt="' + title + '" width="1000" height="1000" loading="eager" class="product-card--image" sizes="(max-width: 767px) calc(50vw - 24px), calc(25vw - 48px)">' +
        '<img src="' + secondaryImage + '&amp;width=600" alt="" width="600" height="600" loading="lazy" class="product-card--hover-image" sizes="(max-width: 767px) calc(50vw - 24px), calc(25vw - 48px)">' +
      '</a>' +
      badgeMarkup +
      '<button class="valthea-card-favorite' + (isFavorite ? ' is-active' : '') + '" type="button" data-favorite-key="' + key + '" aria-label="' + (isFavorite ? 'Remove ' : 'Save ') + title + '" aria-pressed="' + isFavorite + '">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.7 3.6 13A5.4 5.4 0 0 1 11.2 5.3L12 6l.8-.7A5.4 5.4 0 0 1 20.4 13L12 20.7Z"/></svg>' +
      '</button>' +
    '</div>';
  }

  function renderCta(item) {
    var href = '/products/' + encodeURIComponent(item.urlHandle || '');
    var title = escapeHtml(item.name || 'product');
    return '<a class="valthea-card-cta" href="' + href + '" aria-label="Shop ' + title + '">' +
      '<span>Shop now</span>' +
    '</a>';
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.valthea-card-favorite');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.getAttribute('aria-busy') === 'true') return;

    var key = button.getAttribute('data-favorite-key');
    var active = !favoriteProductIds.has(key);
    if (!(window.ValtheaFavoriteContext || {}).loggedIn) {
      loginRedirect();
      return;
    }
    button.setAttribute('aria-busy', 'true');

    fetch(FAVORITES_URL + '/set', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ productId: key, favorite: active })
    }).then(function (response) {
      if (response.status === 401) {
        loginRedirect();
        return null;
      }
      if (!response.ok) throw new Error('Unable to update favorite');
      return response.json();
    }).then(function (result) {
      if (!result) return;
      if (active) favoriteProductIds.add(key);
      else {
        favoriteProductIds.delete(key);
        favoriteProducts = favoriteProducts.filter(function (item) { return String(item.productId) !== key; });
      }
      syncFavoriteButtons();
      renderFavoriteList();
    }).catch(function (error) {
      console.error('Favorite update request failed', error);
    }).finally(function () {
      button.removeAttribute('aria-busy');
    });
  });

  installProductFavoriteButton();
  installSavedItemsDrawer();
  loadFavorites();

  window.ValtheaCollectionCards = {
    renderMedia: renderMedia,
    renderCta: renderCta,
    escapeHtml: escapeHtml,
    refreshFavorites: loadFavorites,
    isReady: function () { return favoritesLoaded; }
  };
})();
